import React from "react";

function RootWidgetContainer(props) {
  const { isEnabled } = props;

  const rootWidgetContainerStyle = () => ({
    width: "100%",
    height: "100%",
    overflow: "auto",
    position: "relative",   //needed for cover to work
  });

  const coverStyle = () => ({
    display: "block",
    position: "absolute",
    height: "100%",
    width: "100%",
    zIndex: 10,
    backgroundColor: "inherit",
    opacity: 0.3
  });

  const renderCover = () => {
    if (isEnabled) return;
    return <div style={coverStyle()} />;
  };

  return (
    <div className={'dx-theme-background-color'} style={rootWidgetContainerStyle()}>
      {renderCover()}
      {props.children}
    </div>
  );
}

export default RootWidgetContainer;
